/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";
import "gsap/EasePack";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText);

import Swiper from "swiper";
import {
	Mousewheel,
	// Autoplay,
	// Thumbs,
	// EffectFade,
	// Navigation,
	// Pagination,
	Scrollbar,
} from "swiper/modules";

import "../vendors/marquee/marquee.js";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Default : Smooth scrolling
let scrollSmooth = false;

const debug = false;

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'no-js' body class
	document.body.classList.remove("no-js");
	gsapPreloader();
	scrollDetection(160);
	menuBurger();
	menuDropdown();
	initBanner();
	bannerToMarquee();
	popinInit();
	toggleInit();
	accordionInit();
	swiperInit();
});

// DOCUMENT RESIZED (avec ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerToMarquee();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Activation/désactivation du scroll
function scrollEnabled(bool) {
	if (bool === false || bool === true) {
		const enableScroll = bool === true;

		if (scrollSmooth) {
			scrollSmooth.paused(!enableScroll);
		}

		// document.documentElement.style.overflowY = enableScroll ? "auto" : "hidden";
	}
}

// Scroll vers une ancre
function scrollToAnchor(scrollOffset = 100) {

	// Fonction pour gérer le défilement
	const scrollToElement = (target) => {
		const element = document.querySelector(target);
		if (element) {
			if (scrollSmooth) {
				// Avec ScrollSmoother
				scrollSmooth.scrollTo(target, true, `top ${scrollOffset}px`);
			} else {
				// Par défaut
				window.scrollTo({
					top:
						element.getBoundingClientRect().top + window.scrollY - scrollOffset,
					behavior: "smooth",
				});
			}
		}
	};

	// au chargement
	const hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollToElement(hashInUrl);
	}

	// avec un [href="#..."]
	const linksWithAnchor = document.querySelectorAll('a[href^="#"]');
	linksWithAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			const anchorHref = link.getAttribute("href");
			if (anchorHref !== "#") {
				event.preventDefault();
				scrollToElement(anchorHref);
			}
		});
	});

	// avec un [data-scrollto]
	const dataWithScrollTo = document.querySelectorAll("[data-scrollto]");
	dataWithScrollTo.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData === "auto") {
				// Calculer la position de défilement pour 'auto'
				const autoOffset = window.innerHeight + window.scrollY - scrollOffset;
				window.scrollTo({
					top: autoOffset,
					behavior: "smooth",
				});
			} else {
				// Utiliser la valeur de data-scrollto comme cible pour scrollToElement
				scrollToElement(anchorData);
			}
		});
	});
}

// Détection du scroll sur le body
const scrollDetection = (scrollOffset = 0) => {
	let position = window.scrollY;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// Détecter la direction du scroll
		let scroll = window.scrollY;
		// Scroll vers le bas
		if (scroll > position) {
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// Scroll vers le haut
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// Scroll max ?
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
};

// Gestion du menu burger
const menuBurger = () => {
	const headerBurgerButton = document.querySelector("#page-header-burger");
	const headerBurgerArea = document.querySelector("#page-header");

	if (headerBurgerButton) {
		headerBurgerButton.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});

		document.addEventListener("mouseup", (event) => {
			if (
				document.body.classList.contains("page-with-fullscreenmenu") &&
				!headerBurgerButton.contains(event.target) &&
				headerBurgerButton !== event.target &&
				!headerBurgerArea.contains(event.target) &&
				headerBurgerArea !== event.target
			) {
				console.log(event);
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			}
		});
	}
};

// Gestion des dropdowns
const menuDropdown = () => {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);



	// DESKTOP MENU 
	const overlay = document.querySelector('.menu-overlay');
	gsap.set('.menu-desktop .swiper', {x:'110%'});
	gsap.set('.menu-desktop', {y:'-100%'});
	const menuTl = gsap.timeline({paused:true})
	.to('.menu-desktop', { 
		y:0,
		duration:.5,
		ease:'power4.out'
	})
	const servicesTl = gsap.timeline({paused:true})
	.to('.menu-desktop .swiper', { 
		x:0,
		duration:2,
		delay:.5,
		ease:'power4.out'
	})

	const etudesTl = gsap.timeline({paused:true})
	.to('.menu-desktop .links a', { 
		y:'0%',
		opacity:1,
		delay:.5,
		stagger:.2,
		duration:.5,
		ease:'power4.inOut'
	})

	document.querySelectorAll('.menu-desktop .etude__link').forEach(function(link, index){
		link.addEventListener('mouseenter',function(){
			document.querySelector('.menu-desktop .address > div:nth-child('+(index+1)+')').classList.add('active');
		})
		link.addEventListener('mouseleave',function(){
			document.querySelector('.menu-desktop .address > div:nth-child('+(index+1)+')').classList.remove('active');
		})
	})

	const menuLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[data-panel]'
	);

	
	menuLinks.forEach(function(menuLink){

		menuLink.addEventListener('mouseenter', function(){

			setTimeout(function(){
				scrollEnabled(false);
			},1000);
			menuTl.play();
			gsap.to(overlay,{opacity:.8});

			if(menuLink.dataset.panel == 'services') {
				gsap.set('.panel-services', {pointerEvents:'all'});
				gsap.set('.menu-desktop',{ height:600 });

				servicesTl.timeScale(1);
				servicesTl.play();
			}

			// etudes 
			if(menuLink.dataset.panel == 'etudes') {
				gsap.set('.panel-etudes', {pointerEvents:'all'});
				gsap.set('.menu-desktop',{ height:400 });
				etudesTl.play();
				//
			}
		})
	})
	document.querySelector('.menu-desktop').addEventListener('mouseleave', function(){

		scrollEnabled(true);
		setTimeout(function(){
			scrollEnabled(true);
		},1000);
		gsap.set('.menu-desktop .panel', {pointerEvents:'none'});
		menuTl.reverse();
		gsap.to(overlay,{opacity:0});
		servicesTl.timeScale(4);
		servicesTl.reverse();
		etudesTl.reverse();
	})


	// EOF // DESKTOP MENU 
	

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});

	});
};

// Activation/désactivation de la bannière
const initBanner = () => {
	// Vérifie si la bannière a déjà été fermée durant cette session
	if (sessionStorage.getItem("bannerClosed") === "true") {
		return;
	}

	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// actualisation
		document.body.classList.add("page-with-banner");
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");

			// Enregistre en session que la bannière a été fermée
			sessionStorage.setItem("bannerClosed", "true");
		});
	}
};

// Gestion du défilement horizontal de la bannière
const bannerToMarquee = () => {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
};

// Data-toggle : Action au clic
function toggleInit() {
	const toggleListeners = document.querySelectorAll("[data-toggle]");

	toggleListeners.forEach((toggleEl) => {
		toggleEl.addEventListener("click", (e) => {
			e.preventDefault();
			e.stopPropagation();
			console.log(e);
			// Récupérer la cible
			let toggleTarget = toggleEl.dataset.toggle;
			toggleTarget = toggleTarget.split(', ');
			if (toggleTarget) {
				console.log(toggleTarget, toggleTarget.length)
				if ( toggleTarget.length == 1 )	{
					document.getElementById(toggleTarget).classList.toggle("--active");
				}
				else {
					toggleTarget.forEach(function(toggleTarg){
						console.log(toggleTarg)
						document.getElementById(toggleTarg).classList.toggle("--active");
					})
				}
			}
		});
	});
}

// Gestions des actions des [data-accordion]
const accordionInit = () => {
	const accordionListeners = document.querySelectorAll("[data-accordion]");

	accordionListeners.forEach((accordionElement) => {
		accordionElement.addEventListener("click", (event) => {
			event.stopPropagation();

			// Retirer la classe "--active" à tous les accordionListeners et accordionTargets
			accordionListeners.forEach((element) => {
				if (element !== accordionElement) {
					const accordionTarget = document.getElementById(
						element.dataset.accordion
					);
					if (accordionTarget) {
						element.classList.remove("--active");
						accordionTarget.classList.remove("--active");
					}
				}
			});

			// Ajouter la classe "--active" à la cible
			if (accordionElement.dataset.accordion) {
				const currentaccordionTarget = document.getElementById(
					accordionElement.dataset.accordion
				);
				if (currentaccordionTarget) {
					accordionElement.classList.add("--active");
					currentaccordionTarget.classList.add("--active");
				}
			}
		});
	});
};

// Gestions des actions des [data-popin]
const popinInit = () => {
	const popins = document.querySelectorAll("[data-popin]");

	popins.forEach((popin) => {
		popin.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popin
			const thispopinName = popin.dataset.popin;
			if (thispopinName) {
				const thispopinEl = document.querySelector(
					`.page__popin#${thispopinName}`
				);
				thispopinEl.classList.toggle("page__popin--open");
			}

			// mettre les vidéos des popins en pause
			const htmlVideoFrompopin =
				document.querySelectorAll(".page__popin video");
			if (htmlVideoFrompopin.length > 0) {
				htmlVideoFrompopin.forEach((video) => {
					video.pause();
				});
			}
		});
	});

	document.addEventListener("mouseup", (event) => {
		// si une popin est ouverte
		if (
			document.querySelectorAll(".page__popin.page__popin--open").length > 0
		) {
			// clic en dehors de la zone
			if (
				!document
					.querySelector(".page__popin .popin__wrapper")
					.contains(event.target) &&
				document.querySelector(".page__popin .popin__wrapper") !== event.target
			) {
				// fermer la popin
				document.querySelectorAll(".page__popin").forEach((popin) => {
					popin.classList.remove("page__popin--open");
				});

				// mettre les vidéos des popins en pause
				const htmlVideoFrompopin =
					document.querySelectorAll(".page__popin video");
				if (htmlVideoFrompopin.length > 0) {
					htmlVideoFrompopin.forEach((popinVideo) => {
						popinVideo.pause();
					});
				}
			}
		}
	});
};

// Convertir les [data-src] en [src]
const srcInit = () => {
	// Select all elements with a data-src attribute
	const srcElements = document.querySelectorAll("[data-src]");
	srcElements.forEach((element) => {
		element.setAttribute("src", element.getAttribute("data-src"));
		element.removeAttribute("data-src");
	});
};

/* -------------------------------- (SWIPER) -------------------------------- */

// Swiper : Initialisation des sliders
function swiperInit() {
	if (
		document.querySelectorAll("#autres-articles .swiper .swiper-slide").length >
		1
	) {
		new Swiper("#autres-articles .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			resizeObserver: true,
			// Modules
			// modules: [Scrollbar],
			// scrollbar: {
			// 	el: "#autres-articles .swiper-scrollbar",
			// 	draggable: true,
			// },
		});
	}

	if ( document.querySelector('.services-swiper')) {
		document.querySelectorAll('.services-swiper').forEach(function(servicesSwiper){
			new Swiper(servicesSwiper, {
				slidesPerView:1,
				spaceBetween:13,
				modules: [Scrollbar, Mousewheel],
				scrollbar: {
					el: servicesSwiper.querySelector(".swiper-scrollbar"),
					dragSize:window.innerWidth > 992 ? 200 : 'auto',
					draggable: true,
				},
				mousewheel:{
					enabled:true,
					releaseOnEdges: true,
				},
				breakpoints: {
					// when window width is >= 320px
					767: {
						slidesPerView: 2,
					},
					992: {
					  slidesPerView: 3,
					},
					1200: {
					  slidesPerView:  4,
					},
					1300: {
					  slidesPerView: servicesSwiper.dataset.size == 'small' ? 5.3 : 4,
					}
				  }
			})
		})
	}
}

/* --------------------------------- (GSAP) --------------------------------- */

// GSAP : Initialisation du scrollSmoother (avec ScrollSmoother)
function initScrollSmooth() {
	scrollSmooth = ScrollSmoother.create({
		wrapper: "#page-wrapper",
		content: "#page-container",
		smooth: 1,
		smoothTouch: false,
		effects: window.innerWidth > 992 ? true : false,
		normalizeScroll: false,
		ignoreMobileResize: true,
	});
}

// GSAP : Découpage des textes (avec SplitText)
function gsapSplitText() {
	const textsToAnimated = document.querySelectorAll([
		// global
		'[data-animation^="reveal-text"]',
		".elementor-heading-title",
	]);

	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			tag: "span",
			// type: "lines, words, chars",
			type: "lines, words",
			linesClass: "line",
			wordsClass: "word",
			charsClass: "char",
		});
	});
}

// GSAP : Animations au scroll (avec ScrollTrigger)
function gsapAnimations() {
	// [data-animation] + .elementor-element
	const elementsToAnimated = document.querySelectorAll([
		"[data-animation]",
		".elementor-heading-title",
		".elementor-element > .elementor-element > .elementor-element:not([data-animation])",
	]);
	elementsToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	// data-animation="counter"
	const elementsToCounter = document.querySelectorAll(
		'[data-animation="counter"]'
	);
	elementsToCounter.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			// markers: true,
			onEnter: () => {
				setTimeout(() => {
					gsap.from(_this, {
						duration: 1.5,
						textContent: 0,
						snap: { textContent: 1 },
						stagger: {
							each: 1.0,
							onUpdate: function () {
								this.targets()[0].innerHTML = Math.ceil(
									this.targets()[0].textContent
								)
									// conserver les "."
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
									// conserver les espaces
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
							},
						},
					});
				}, delay);
			},
		});
	});

	// data-animation="reveal-text"
	const textsToAnimate = document.querySelectorAll([
		'[data-animation="reveal-text"]',
		'.elementor-heading-title'
	]);
	textsToAnimate.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		gsap.to(_this.querySelectorAll(".word"),{
			scrollTrigger: {
				trigger: _this,
				start: "top 100%",
				// markers:true,
			},
			delay: delay,
			stagger: 0.04,
			ease: "power1.out",
			opacity: 1,
			y:0
		})
	})


	// data-animation="reveal-text-reading"
	const textsToReading = document.querySelectorAll([
		'[data-animation="reveal-text-reading"]',
	]);
	textsToReading.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		gsap.fromTo(
			_this.querySelectorAll(".word"),
			{
				opacity: 0.33,
			},
			{
				delay: delay,
				stagger: 0.3,
				ease: "power1.out",
				opacity: 1,
				scrollTrigger: {
					trigger: _this,
					start: "top 88%",
					end: "top 22%",
					scrub: true,
					// markers: true,
				},
			}
		);
	});

	// data-animation="skid"
	const elementsToskid = document.querySelectorAll([
		'body:not(.elementor-editor-active) [data-animation="skid"]',
	]);
	elementsToskid.forEach((_this) => {
		gsap.to(_this, {
			scrollTrigger: {
				trigger: _this,
				pin: true,
				pinSpacing: false,
				start: "top top",
				// markers: true,
			},
		});
	});


	// if ( document.querySelector('#home-hero')) {
	// 	gsap.fromTo('#home-hero svg', { x:'-5%'}, { x:'0%', duration:3, ease:'power3.out'})
	// }

	setTimeout(function(){
		document.querySelector('.page__header .header__navbar').classList.add('active');
	},1000);
}

// Actions exécutées après le preLoader d'accueil
function afterPreloader() {
	scrollEnabled(true);
	swiperInit();
	gsapAnimations();
	scrollToAnchor();
}

// GSAP : Rafraîchissement du ScrollSmoother (avec ScrollSmoother)
const gsapScrollSmootherRefresh = () => {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
};

// GSAP : Gestion du preloader d'accueil
const loaderTimeline = gsap.timeline();
const gsapPreloader = () => {
	// Chargement des fonctions GSAP préalables
	initScrollSmooth();
	scrollEnabled(false);
	gsapSplitText();

	// Lancement de l'animation de chargement
	if ( !document.querySelector('.home') ) loaderTimeline.timeScale(3);
	loaderTimeline
		// animation
		.to("#page-preloader .preloader__logo svg", {
			strokeDashoffset:0,
			duration:3
		})
		.to("#page-preloader .preloader__logo", {
			scale:1,
			duration:3,
		},'<')
		.to("#page-preloader .preloader__title", {
			scale:.9,
			duration:3,
		},'<')
		.to("#page-preloader", {
			clipPath:'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
			delay: debug?0:2.5,
			duration: 1.4,
			ease: "power4.out",
		},'<')

	// Functions succédentes
	loaderTimeline.add(afterPreloader, debug ? 0 : loaderTimeline.duration() - 1.5);
};



if ( document.querySelector('#home-slides')) {

	document.querySelectorAll('#home-slides .slide').forEach((slide) => {
		
		// text 
		const slideText = slide.querySelector('.slide__text');
		gsap.set(slideText,{y:'-100vh'});
		gsap.to(slideText,{
			scrollTrigger:{
				trigger:slide,
				start: "top bottom",
				end: "bottom top",
				scrub:true
			},
			y:'100vh',
			ease:'none'
		})

		// background 
		if ( window.innerWidth > 992 ) {
			const slideBackground = slide.querySelector('.slide__image');
			gsap.set(slideBackground,{y:'-50vh', scale:1.2});
			gsap.to(slideBackground,{
				scrollTrigger:{
					trigger:slide,
					start: "top bottom",
					end: "bottom top",
					scrub:true
				},
				y:'50vh',
				scale:1,
				ease:'none'
			})
		}

		// borders 
		const slideBorders = [ document.querySelector('#home-slides .b-left'), document.querySelector('#home-slides .b-right')]
		gsap.to(slideBorders,{
			scrollTrigger:{
				trigger:'#home-slides',
				start: "top bottom",
				end: "center center",
				scrub:true
			},
			width:30,
			ease:'none'
		})
	})

}


if (document.querySelector('#etudes-map') && window.innerWidth > 992) {
	ScrollTrigger.create({
		trigger:'#etudes-list .etudes-list',
		start: "top 30%",
		end: "bottom 80%",
		pin:'#etudes-map',
	})
	document.querySelectorAll('.etudes-list a').forEach(function(etude, index){
		etude.addEventListener('mouseenter', function(){
			gsap.to('.marker:not(:nth-child('+(index+1)+')), .leximpact-markers', { opacity:0.3 })
		})
		etude.addEventListener('mouseleave', function(){
			gsap.to('.marker, .leximpact-markers', { opacity:1 })
		})
	})
}



document.querySelectorAll('a').forEach(function(link){
	if(link.target != '_blank' && !link.href.includes('#')) {
		link.addEventListener('click',function(e){
			e.preventDefault();
			window.location = link.href;
			loaderTimeline.timeScale(4);
			loaderTimeline.reverse();
			// loaderTimeline.reverse().then(function(){
			// 	window.location = link.href;
			// });
		})
	}
})


if ( document.querySelector('.form-big-radio')) {
	const formNav = document.querySelector('.form-big-radio');
	gsap.set('.form-big-radio + .wpcf7', {display:'none'})
	document.querySelectorAll('.form-big-radio input').forEach(function(input){
		input.addEventListener('change',function(){
			if ( input.value == 1 ) {
				document.querySelector('[data-name="radio-prestations"] .last').style.display = 'none';
			} 
			if ( input.value == 2 ) {
				document.querySelector('[data-name="radio-prestations"] .last input').checked = true;
				document.querySelector('.to-hide').style.display = 'none';
			} 
			gsap.to('.form-big-radio .label', {
				x:-30,
				opacity:0,
				stagger:.2,
				onComplete:function(){
					gsap.set('.form-big-radio', {display:'none'})
					gsap.set('.form-big-radio + .wpcf7', {display:'block', opacity:0})
					gsap.to('.form-big-radio + .wpcf7', { opacity:1})

				}
			})
		})
	})


	if ( window.innerWidth > 992 ) {
		gsap.to('.section__form-image', {
			scrollTrigger:{
				trigger:'.section__form-image',
				start:'top top',
				end:'bottom top',
				scrub:true,
				pin:'.section__form-image img'
			},
		})
	}
}


if ( document.querySelector('.section-services .services-swiper')) {

	gsap.set('.section-services .title-h5', { x:'100%', opacity:0 });
	gsap.set('.section-services .services-swiper', { x:'110%'});
	document.querySelectorAll('.section-services .services-swiper .swiper-slide').forEach(function(slide, index){
		slide.style.marginLeft = (index * 50) + 'px';
	})

	const homeServicesTimeline = gsap.timeline()
	.to('.section-services .services-swiper', {
		x:0,
		duration:1 
	})
	.to('.section-services .swiper-slide', {
		marginLeft:0,
		duration:1.5,
		ease:'Power3.out'
	}, '<')
	.to('.section-services .title-h5', {
		opacity:1,
		x:0,
		duration:1 
	}, '<+.1')

	ScrollTrigger.create({
		animation:homeServicesTimeline,
		trigger:'.section-services .services-swiper',
		start:'top 80%',
		end:'bottom bottom',
        onLeaveBack: ()=> { 
			homeServicesTimeline.reverse();
		}
	})

}

if ( document.querySelector('.section-archive-related-news') ) {
	document.querySelector('.section-archive-related-news .section__list')
	gsap.set('.section-archive-related-news .section__list .excerpt__image img', { scale:1.3 });
	const newsTimeline = gsap.timeline()
	.to('.section-archive-related-news .section__list .excerpt__image img', {
		scale:1,
		duration:.3 
	})
	ScrollTrigger.create({
		animation:newsTimeline,
		trigger:'.section-archive-related-news .section__list',
		start:'top bottom',
		end:'bottom bottom',
        onLeaveBack: ()=> { 
			newsTimeline.reverse();
		}
	})

} 

if ( document.querySelector('#section-recouvrement')) {
	document.querySelector('#section-recouvrement').addEventListener('mousemove', function(e){
		const xMultiplicator = (e.clientX / window.innerWidth - 0.5) * 2; // from -1 to 1 
		const yMultiplicator = (e.clientY / window.innerHeight - 0.5) * 2; // from -1 to 1 
		gsap.to('.recouvrement__animation + .container', {
			x: xMultiplicator * 10,
			y: yMultiplicator * 10,
		})
		gsap.to('.money, .sms, .count', {
			x: xMultiplicator * 30,
			y: yMultiplicator * 30,
			stagger:.1
		})
	})

	// borders 
	const slideBorders = [ document.querySelector('#section-recouvrement .b-left'), document.querySelector('#section-recouvrement .b-right')]
	gsap.to(slideBorders,{
		scrollTrigger:{
			trigger:'#section-recouvrement .container-fluid',
			start: "top bottom",
			end: "center center",
			scrub:true
		},
		width:30,
		ease:'none'
	})
}



// FAQ
if ( document.querySelector('.section-faq') ) {

	gsap.set('.faq-item', { opacity:0 })
	setTimeout(function(){
		gsap.set('.faq-item', { opacity:0, y:100 })
		const faqTl = gsap.timeline({paused:true})
		.to('.faq-item', {
			opacity:1, 
			y:0,
			ease:'Power3.easeOut',
			duration:0.5,
			stagger:0.1,
		});
		ScrollTrigger.create({
			trigger:'#faq0',
			start:"top center+="+window.innerHeight/4,
			toggleActions:"play none none reverse",
			animation:faqTl,
		})
	},200)
}


if (document.querySelector('#home-hero') ){
	document.querySelectorAll('.enchere').forEach(function(enchere, index){

		gsap.set(enchere, {opacity:0, y:-20})

		const encheresTlg = gsap.timeline({repeat:-1, delay:3*(index+2), repeatDelay:2.9*(document.querySelectorAll('.enchere').length - 1)})
		.to(enchere, {
			y:0,
			opacity:1,
			duration:1,
			ease:'power3.out'
		})
		.to(enchere, {
			y:20,
			opacity:0,
			ease:'power3.out'
		},'<3')
		
	})

}

if( document.querySelector('.scroll-invite') ) {
	document.querySelector('.scroll-invite').addEventListener('click',function(e){
		if (scrollSmooth) {
			// Avec ScrollSmoother
			scrollSmooth.scrollTo(window.innerHeight, true);
		} else {
			// Par défaut
			window.scrollTo({
				top:window.innerHeight,
				behavior: "smooth",
			});
		}
	})
}


if (document.querySelector('#acta-recouvrement-hand') ){
	gsap.set('#acta-recouvrement-hand', { scale:0, rotate:720,	})
	gsap.set('#acta-recouvrement-hand img', { opacity:0, y:'30%', x:'30%' })
	gsap.set('#acta-recouvrement-hand #bubble-1, #acta-recouvrement-hand #bubble-2', { opacity:0, y:'100%' })
	gsap.set('#acta-recouvrement-hand #bubble-1 .icon, #acta-recouvrement-hand #bubble-2 .icon', { scale:0, opacity:0, y:'100%', transformOrigin:'40% 50%' })
	gsap.set('#acta-recouvrement-hand #flash-1, #acta-recouvrement-hand #flash-2', { opacity:0, scale:0, transformOrigin:'40% 50%' })
	gsap.set('#acta-recouvrement-hand #zigwigwi', { opacity:0, scale:0, transformOrigin:'40% 50%' })
	gsap.set('#acta-recouvrement-hand #dots', { opacity:0, scale:0, transformOrigin:'40% 50%' });

	const mobileAnimation = gsap.timeline({paused:true, repeat:-1, yoyo:true, repeatDelay:1})
	.to('#acta-recouvrement-hand', {
		scale:1,
		rotate:0,
	})
	.to('#acta-recouvrement-hand img', {
		opacity:1,
		x:0,
		y:0
	})
	.to('#acta-recouvrement-hand #zigwigwi', { opacity:1, scale:1, ease:'Power2.bounce' }, '<')
	.to('#acta-recouvrement-hand #dots', { opacity:1, scale:1, ease:'Power2.bounce' }, '<')
	.to('#acta-recouvrement-hand #flash-1, #acta-recouvrement-hand #flash-2', { opacity:1, scale:1, ease:'Power2.bounce' }, '<')
	.to('#acta-recouvrement-hand #bubble-1', {
		opacity:1,
		duration:0.2,
		y:0
	})
	.to('#acta-recouvrement-hand #bubble-1 .icon', {
		opacity:1,
		scale:1,
		duration:0.2,
		y:0
	})
	.to('#acta-recouvrement-hand #bubble-2', {
		opacity:1,
		duration:0.2,
		y:0
	},'>.5')
	.to('#acta-recouvrement-hand #bubble-2 .icon', {
		opacity:1,
		scale:1,
		duration:0.2,
		y:0
	})

	ScrollTrigger.create({
		trigger: '#acta-recouvrement-hand',
		start: "top 80%",
		end: "bottom 0",
		onEnter: () => {
			mobileAnimation.play();
		},
		onLeaveBack: () => {
		},
	});


}

if ( document.querySelector('.recouvrement__animation')) {
	gsap.set('.recouvrement__animation .circle path', {scale:.6, transformOrigin:'50% 50%'})
	gsap.to('.recouvrement__animation .circle path', {
		scrollTrigger:{
			trigger:'.recouvrement__animation',
			start:'top top',
			end:'bottom top',
			scrub:true
		},
		scale:1
	})
}



if ( document.querySelector('#select-etude')) {

	console.log(document.querySelector('#select-etude').parentElement)
	const form = document.querySelector('#select-etude').parentElement;
	document.querySelectorAll('#select-etude input[name="radioEtude"]').forEach(function(radio){
		radio.addEventListener('change',function(){
			if( document.querySelector( 'input[name="radioEtude"]:checked').value == 'acta') {
				form.action = "https://mondossier.acta.happilote.com/form/submit/payment";
			} else {
				form.action = "https://mondossier.actallier.happilote.com/form/submit/payment";
			}
			console.log(document.querySelector( 'input[name="radioEtude"]:checked').value);
		})
	})
}

if ( document.querySelector('.home-services')) {
	
	if ( window.innerWidth > 992 ) {
		let services = gsap.utils.toArray(".home-services .swiper-slide");
		let scrollServices = gsap.to(services, {
			xPercent: -100 * (services.length - 1),
			ease: "none",
			scrollTrigger: {
			trigger: ".home-services",
			start:'50% 50%',
			pin: true,
			scrub: 0.1,
			end: "+=3000",
			onUpdate:(e) => {
				console.log(e);
				gsap.to('.home-services .line path', { strokeDashoffset:2100 - 2100 * e.progress });
			}
			}
		});

		

	} else {
		const servicesSwiper = document.querySelector('.home-services');
		new Swiper(servicesSwiper, {
			slidesPerView:1,
			spaceBetween:13,
			modules: [Scrollbar],
			scrollbar: {
				el: servicesSwiper.querySelector(".swiper-scrollbar"),
				dragSize:window.innerWidth > 992 ? 200 : 'auto',
				draggable: true,
			},
			breakpoints: {
				// when window width is >= 320px
				767: {
					slidesPerView: 2,
				},
				992: {
				slidesPerView: 3,
				},
				1200: {
				slidesPerView:  4,
				},
				1300: {
				slidesPerView: servicesSwiper.dataset.size == 'small' ? 5 : 4,
				}
			}
		})
	}
	
}


if ( document.querySelector('#happilote-screen')) {
	
	if ( window.innerWidth > 992 ) {
		gsap.to('#happilote-screen .screen', {
			width: window.innerWidth,
			ease: "none",
			scrollTrigger: {
				trigger: "#happilote-screen",
				start:'50% 50%',
				pin: true,
				scrub: 0.1,
				end: "+=1000",
			}
		});
	}
}